import React, { useState } from 'react'
import DataGridSkeleton from '../../shared/components/DataGridSkeleton';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../shared/utils/CustomPagination';
import { Typography } from '@mui/material';

const CourseTableList = ({ courseRow, isLoading }) => {
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 });
    const courseColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "course_fees",
            headerName: "Course Fees",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "start_date",
            headerName: "Start Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{  params.value}</Typography>,
        },
        {
            field: "end_date",
            headerName: "End Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        // {
        //     field: "start_time",
        //     headerName: "Start Time",
        //     flex: 1,
        //     renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        // },
        // {
        //     field: "end_time",
        //     headerName: "End Time",
        //     flex: 1,
        //     renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        // },
    ];
    return (
        <>

            {isLoading ? (
                <DataGridSkeleton rowsNum={10} />
            ) : (
                <DataGrid
                    rows={courseRow}
                    columns={courseColumns}
                    pagination
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[10]}
                    disableRowSelectionOnClick={true}
                    slots={{
                        pagination: () => (
                            <CustomPagination
                                paginationModel={paginationModel}
                                setPaginationModel={setPaginationModel}
                                totalRows={courseRow?.length || 0}
                                pageSize={paginationModel.pageSize}
                            />
                        ),
                    }}
                />
            )}
        </>
    )
}

export default React.memo(CourseTableList);